@if (settingsStore.locale$ | async; as locale) {
    @if (footerStore.state$ | async; as state) {
        <dsw-footer [locale]="locale" viessmannLogoUrl="/">
            <div version>
                <span [attr.version]="state.version" data-testid="app-version">{{ 'FOOTER.APP' | translate }} {{ state.appVersion }}</span>
            </div>
            <span version>|</span>
            <span version>{{ 'FOOTER.API' | translate }} {{ state.apiVersion }}</span>
            <span version>|</span>
            <span version>{{ 'FOOTER.CALCULATION_API' | translate }} {{ state.calculationApiVersion }}</span>
        </dsw-footer>
    }
}
